import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { Dispatch, SetStateAction } from 'react';

import { ChevronDownIcon } from '@chakra-ui/icons';

interface WarmNeutralMenuProps {
  label: string;
  selected: { name: string; value: string | null } | null;
  setSelected: Dispatch<SetStateAction<{ name: string; value: string | null } | null>>;
  options: { name: string; value: string | null }[];
  minWidth?: number;
}

export default function WarmNeutralMenu({
  label,
  selected,
  setSelected,
  options,
  minWidth,
}: WarmNeutralMenuProps) {
  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon color="baseBlack" />}
        backgroundColor="white"
        color="baseBlack"
        fontSize="14px"
        fontWeight={500}
        paddingY="14px"
        paddingX={3}
        border="1px solid"
        borderColor="warmNeutral.200"
        borderRadius="6px"
        minWidth={minWidth}
        textAlign="left"
        _hover={{ backgroundColor: 'warmNeutral.0' }}
        _active={{ backgroundColor: 'warmNeutral.0' }}
      >
        {label} {selected?.name}
      </MenuButton>

      <MenuList
        border="1px solid"
        borderColor="warmNeutral.200"
        borderRadius="6px"
        boxShadow="0px 4px 12px 0px rgba(0, 0, 0, 0.15)"
        paddingX={4}
      >
        {options.map((option, index) => (
          <MenuItem
            key={option.value}
            color="baseBlack"
            fontSize="14px"
            fontWeight={500}
            borderBottom={index !== options.length - 1 ? '1px solid' : 'none'}
            borderBottomColor="neutral.100"
            paddingY={4}
            _hover={{ backgroundColor: 'warmNeutral.0' }}
            onClick={() =>
              setSelected({
                name: option.name,
                value: option.value ?? '',
              })
            }
          >
            {option.name}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}
